export const WARNING_MESSAGE = {
    HOMEPAGE: {
        SUBMISSION_FORM: {
            id: 1
        },
    }
}